/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const headerNavBarDropMenuSX: SxProps = {
	borderTopRightRadius: 0,
	borderTopLeftRadius: 0,
	maxWidth: 'calc(100vw - 40px)',
	boxShadow: 6,
	backgroundColor: 'white',
	color: 'background.contrastText',
	'@media (hover: hover)': {
		p: 0,
	},

	'.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
		'@media (hover: hover)': {
			mt: 0,
			ml: -2,
		},
		'@media (hover: none)': {
			mt: '1px',
			p: '0',
		},
	},
};

export const headerNavBarDropMenuStickyBarSX: SxProps = {
	backgroundColor: 'background.paper',
	gap: '10px',
	pb: '15px',
	position: 'sticky',
	bottom: 0,
	zIndex: 1000,
};

export const headerNavBarDropMenuStickyContainerSX: SxProps = {
	gap: '20px',
	p: '10px',
};

export const headerNavBarDropMenuStickySubtotalSX = {
	color: '#333333',
	fontWeight: OpenSansFontWeights.semibold,
};

export const signInRegisterPanelSX: SxProps = {
	borderTopRightRadius: 0,
	borderTopLeftRadius: 0,
	maxWidth: 'calc(100vw - 40px)',
	boxShadow: 2,
	backgroundColor: 'background.paper',
	color: 'background.contrastText',
	'@media (hover: hover)': {
		py: 0,
		px: 1,
	},

	'.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
		'@media (hover: hover)': {
			mt: 0,
			ml: -2,
		},
		'@media (hover: none)': {
			mt: 0.75,
		},
	},
};
